export class Onboarding{
	linkedIn: String;
	about: String;
	status: String;
	student_id: String;
	notes: string;
	admin_notes: string;
	resume : string;
	is_interested:boolean= false;
  }